module.exports = __webpack_public_path__ + "static/media/nav-menu.5ed81d50.svg";